import { Component, Input } from '@angular/core';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { take } from 'rxjs';
import { UserDataService } from 'src/app/shared/services/user-data.service';

@Component({
  selector: 'app-health-issues',
  templateUrl: './health-issues.component.html',
  styleUrls: ['./health-issues.component.scss'],
})
export class HealthIssuesComponent {
  @Input() userUID: string | undefined;
  healthIssues: any;
  personal = '../../../../assets/images/health (1).png';
  constructor(
    private firestore: AngularFirestore,
    public userDataService: UserDataService
  ) {}

  ngOnInit(): void {
    this.getPersonalInfo();
  }

  getPersonalInfo() {
    this.firestore
      .collection('healthIssues')
      .doc(this.userUID)
      .get()
      .pipe(take(1))
      .subscribe((data: any) => {
        let obj = data.data();
        this.healthIssues = obj;
        this.userDataService.dataSubject.next(this.healthIssues.medicalHistory);
      });
  }
}
